const KeywordDescription = ({
    keywordDescription
}) => {
    return (
        <>
            {/* KW文章 */}
            <div className="p-knowledge">
                {keywordDescription.hasLocation ?
                    <h4 className="p-knowledge_title">About {keywordDescription.keywordOfSearchResultViewModel} Jobs in {keywordDescription.locationForDisplay}</h4> :
                    <h4 className="p-knowledge_title">About {keywordDescription.keywordOfSearchResultViewModel} Jobs</h4>
                }
                {keywordDescription.isJobCountDisplayable &&
                    <p className="p-knowledge_text">{keywordDescription.jobCountDescription}</p>
                }
                <p className="p-knowledge_text">{keywordDescription.keywordDescription}</p>
            </div>
            {/* /  KW文章 */}
        </>
    );
}

export default KeywordDescription;
